import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';
import { isNullOrUndefined } from 'util';
import { MasterSummaryPDModel, MasterSummaryQuestionModel } from '../../../../models/survey/survey.model';
import { PARALLEL_CHART_COLORS } from '../../../helpers/chart-helper';
import { CommunicationService } from '../../../services/communication.service';

@Component({
  selector: 'app-parallel-coordinate-chart',
  templateUrl: './parallel-coordinate-chart.component.html',
  styleUrls: ['./parallel-coordinate-chart.component.less']
})
export class ParallelCoordinateChartComponent implements OnInit {

  @Input() dataSource: MasterSummaryPDModel;
  @Input() chartJ: number;
  @Input() isSelectedAllResponses: boolean;
  @Input() questionI: number;
  
  chartOption: any;
  oldDataSource: string;
  
  initOpts = {
    renderer: 'canvas',
    width: 0,
    height: 500
  };

  constructor(private communicationService: CommunicationService) {
    
  }
  ngOnInit() {
    this.communicationService.scrollDataChanged.subscribe(() => {
        if (this.oldDataSource !== JSON.stringify(this.dataSource)) {
            this.oldDataSource = JSON.stringify(this.dataSource);
            this.initChart();
        }
    })

    this.initChart();
  }

  initChart() {
    let chartWidth = 0;
    const barWidth = 120;
    let parallelAxis: any[] = [];
    let parallelDataTemp: {} = {};
    let segmentNames: string[] = [];

    if (this.isSelectedAllResponses) {
        let data: Number[] = [];
        for(let i = 0; i < this.dataSource.listQuestionModel[this.chartJ].listAnswerModel.length; i++){
            data.push(this.getAnswerPercentage(this.dataSource.listQuestionModel[this.chartJ].listAnswerModel[i]));
        }
        parallelDataTemp['ALL RESPONSES'] = data;
        segmentNames.push('ALL RESPONSES');
    }
    if (this.dataSource.listSurveyVersionQuestion && this.dataSource.listSurveyVersionQuestion.length > 0) {
        this.dataSource.listSurveyVersionQuestion.forEach(question => {
            if (!isNullOrUndefined(question.listQuestionModel[this.chartJ])) {
                let data: Number[] = [];
                for(let i = 0; i < question.listQuestionModel[this.chartJ].listAnswerModel.length; i++){
                    data.push(this.getAnswerPercentage(question.listQuestionModel[this.chartJ].listAnswerModel[i]));
                }
                parallelDataTemp[question.surveyName] = data;
                segmentNames.push(question.surveyName);
            }
        }) 
    }
    if (this.dataSource.listSurveyCutQuestion && this.dataSource.listSurveyCutQuestion.length > 0) {
        this.dataSource.listSurveyCutQuestion.forEach(question => {
            if (!isNullOrUndefined(question.listQuestionModel[this.chartJ])) {
                let data: Number[] = [];
                for(let i = 0; i < question.listQuestionModel[this.chartJ].listAnswerModel.length; i++){
                    data.push(this.getAnswerPercentage(question.listQuestionModel[this.chartJ].listAnswerModel[i]));
                }
                parallelDataTemp[question.surveyName] = data;
                segmentNames.push(question.surveyName);
            }
        }) 
    }
    chartWidth = (this.dataSource.listQuestionModel[this.chartJ].listAnswerModel.length - 1) * barWidth;
    this.initOpts.width = chartWidth + 450;

    let parallelData: any[] = [];
    let maxValue = 0;
    for (let index = 0; index < segmentNames.length; index++) {
        const max = _.maxBy(parallelDataTemp[segmentNames[index]], function(o) { return o });
        if (max > maxValue) {
            maxValue = max;
        }
        parallelData.push({
            name: segmentNames[index],
            type: 'parallel',
            lineStyle: {
                width: 4,
                opacity: 1
            },
            data: [
                parallelDataTemp[segmentNames[index]]
            ]
        })
    }

    for (let index = 0; index < this.dataSource.listQuestionModel[this.chartJ].listAnswerModel.length; index++) {
        parallelAxis.push(
            { 
                dim: index,
                name: this.dataSource.listQuestionModel[this.chartJ].listAnswerModel[index].answerName,
                min: 0,
                max: this.roundMaxValue(maxValue)
            });
    }

    this.chartOption = {
        color: PARALLEL_CHART_COLORS,
        legend: {
            icon: 'rect',
            data: segmentNames,
            textStyle: {
              fontSize: 14,
              borderRadius: 0,
            },
            itemGap: 20,
            orient: 'vertical',
            top: 'middle',
            left: this.initOpts.width - 350,
            tooltip: {
                show: true,
                trigger: 'item',
                padding: 10,
                borderRadius: 0,
                shadowColor: null,
                borderColor: '#5E5E5E',
            },
        },
        tooltip: {
            padding: 10,
            borderRadius: 0,
            shadowColor: null,
            formatter: (params) => {
                return params.seriesName;
            }
        },
        parallel: {
            width: chartWidth,
            left: 50,
            right: 0,
            bottom: 30,
            top: 50,
        },
        parallelAxis: parallelAxis,
        series: parallelData
    };
  }

  getResponseLabel(item) {
    const answerCount = item.answerCount != null ? item.answerCount : item.answeredCount
    return answerCount >= 0 ? answerCount : 0
  }

  getAnswerPercentage(item){
    return (item.answerPercentage && Number(item.answerPercentage) > 0 ) ? Number(item.answerPercentage) : 0
  }

  private roundMaxValue(max) {
    if (max > 0 && max <= 100) {
        return Math.ceil(max / 10) * 10;
    }

    return max;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/parallel-coordinate-chart/parallel-coordinate-chart.component.ts